import scraperApi from "api";
import { PricingOptionsDataRouteType } from "routes/data-routes/billing-data/pricing-options/route.meta";


export const loader: PricingOptionsDataRouteType["route"]["loader"] = async ({ request }) => {
  return {
    pricingOptions: await scraperApi.subscription.getPricingOptions({ signal: request.signal })
  };
};
